import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CodaltComponent } from 'app/codalt.component';
import { Customer } from '../customer';
import { CustomerProjectDrilling } from '../customer-project-drilling.interface';
import { PdfStyle } from '../pdf-style';
import { PdfStyleService } from '../pdf-style.service';
import { CustomerProjectService } from '../services/customer-project/customer-project.service';
import { CustomerService } from '../services/customer/customer.service';
import { PageTitleService } from '../services/page-title/page-title.service';

@Component({
    selector: 'app-customer-report',
    templateUrl: './customer-report.component.html',
    styleUrls: ['./customer-report.component.scss'],
    standalone: false,
})
export class CustomerReportComponent extends CodaltComponent implements OnInit {
    customer: Customer;
    project: CustomerProjectDrilling;
    date = new Date();
    pdfStyle: PdfStyle | null = null;
    pdfStyleKey: string | null = null;

    constructor(
        private customerService: CustomerService,
        private customerProjectService: CustomerProjectService,
        private pdfStyleService: PdfStyleService,
        private route: ActivatedRoute,
        private pageTitleService: PageTitleService
    ) {
        super();
    }

    get projectDescriptionHtml(): string {
        return this.project?.description || this.project?.extra?.description || '';
    }

    hasProjectDescription(): boolean {
        if (!this.projectDescriptionHtml) {
            return false;
        }

        return (
            this.projectDescriptionHtml
                .replace(/<[^>]+>/g, ' ')
                .replace(/&nbsp;/gi, ' ')
                .trim().length > 0
        );
    }

    ngOnInit(): void {
        this.pageTitleService.setTitle('Rapport klantgebied');
        const styleKey = this.route.snapshot.queryParams['pdf_style'];
        if (styleKey) {
            this.pdfStyleKey = styleKey;
            this.pdfStyleService.getStyles().subscribe(styles => {
                this.pdfStyle = styles.find(s => s.key === styleKey) ?? null;
                this.pdfStyleService.applyPrimaryColor(this.pdfStyle);
            });
        }
        this.watchRouteParams(this.RouteParamnames.customerId, ({ customerId }) => {
            this.subscriptions.add(
                this.customerService.getSingle(+customerId).subscribe(data => {
                    this.customer = data;
                    this.pageTitleService.setTitle('Rapport klantgebied', this.customer.customer_name);
                })
            );
        });
        const queryParams = this.route.snapshot.queryParams;
        this.subscriptions.add(
            this.customerProjectService.getProjectDetail(+queryParams['project']).subscribe(data => {
                this.project = data.data as any as CustomerProjectDrilling;
                setTimeout(() => document.body.appendChild(document.createElement('readyforpuppeteer')));
            })
        );
    }
}
